/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InputAction, ModalController } from "../../../../viewModel/navigation";
import { UnityAppDispatch, UnityRootState } from "../../../../viewModel";
import {
  selectActiveRecordingOption,
  setActiveOptionFocusIndex,
  selectActiveOptionFocusIndex,
  commitPendingActiveOptionValue,
  closeOptionValue,
  tickActiveOptionFocus
} from "../../../../viewModel/myHub/seriesRecordingOptions";

/** Modal name constant for the ListSelectionDialog modal. */
export const LIST_SELECTION_DIALOG_MODAL_NAME: string = "LIST_SELECTION_DIALOG";

/**
 * ModalController for the ListSelectionDialog sub-panel.
 *
 *   NAV_UP / NAV_DOWN  → navigate list items
 *   NAV_OK             → commit the focused item and close
 *   BACK               → discard and close
 */
export class ListSelectionDialogController extends ModalController {
  private readonly mDispatch: UnityAppDispatch;
  private readonly mGetState: () => UnityRootState;

  public constructor(
    dispatch: UnityAppDispatch,
    getState: () => UnityRootState
  ) {
    super(LIST_SELECTION_DIALOG_MODAL_NAME);
    this.mDispatch = dispatch;
    this.mGetState = getState;
  }

  protected initialize(): void {
    this.registerHandler(InputAction.NAV_UP, (): boolean => {
      const current: number = selectActiveOptionFocusIndex(this.mGetState());
      if (current > 0) {
        this.mDispatch(setActiveOptionFocusIndex(current - 1));
      }
      return true;
    });

    this.registerHandler(InputAction.NAV_DOWN, (): boolean => {
      const state = this.mGetState();
      const current: number = selectActiveOptionFocusIndex(state);
      const option = selectActiveRecordingOption(state);
      const lastIndex: number =
        option !== undefined &&
        option.horizontalOptions !== undefined &&
        option.horizontalOptions.length > 0
          ? option.horizontalOptions.length - 1
          : 0;
      if (current < lastIndex) {
        this.mDispatch(setActiveOptionFocusIndex(current + 1));
      }
      return true;
    });

    this.registerHandler(InputAction.NAV_OK, (): boolean => {
      this.mDispatch(tickActiveOptionFocus());
      this.mDispatch(commitPendingActiveOptionValue());
      return true;
    });

    this.registerHandler(InputAction.BACK, (): boolean => {
      this.mDispatch(closeOptionValue());
      return true;
    });
  }
}
